import styled from "styled-components";

import theme from "/theme/default";

import { InfoBannerVariants } from "./InfoBanner.types";

const InfoBannerVariantColorMap: Record<InfoBannerVariants, string> = {
  default: theme.colors.backgroundSurfaceHover,
  info: theme.colors.brandLightBlue,
  alert: theme.colors.backgroundAbnormalFlag,
};

export const InfoBannerContainer = styled.div<{
  variant: InfoBannerVariants;
  bannerColor?: string;
}>(({ theme, variant, bannerColor }) => ({
  display: "flex",
  flexDirection: "row",
  borderRadius: 12,
  gap: 12,
  padding: theme.spacing.standard,
  color: "textPrimary",
  backgroundColor: bannerColor ? bannerColor : InfoBannerVariantColorMap[variant],
}));

export const InfoBannerInnerContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: 8,
});

export const InfoBannerLink = styled.a(({ color }) => ({
  width: "fit-content",
  color: color,
  borderBottom: `1px solid ${color}`,
  "&:focus": {
    outline: "none",
  },
}));
